import posthog from "posthog-js";

/**
 * BRE-9846: PostHog captures nothing while the page belongs to someone else's
 * account (Switch user, View as member, or another tab's switch), or the
 * signed-in person's events and replays land on that account.
 *
 * Held in memory, not posthog's persisted opt-out: every start and end of an
 * impersonation is a hard reload that recomputes it, so a tab closed
 * mid-impersonation cannot leave capture off for the real person. `AuthProvider`
 * sets it in a layout effect, which runs before `posthog.init` and every child's
 * mount effect.
 */
let paused = false;

export function isAnalyticsPaused(): boolean {
  return paused;
}

export function pauseAnalytics(): void {
  if (paused) return;
  paused = true;
  if (posthog.__loaded) posthog.stopSessionRecording();
}

export function resumeAnalytics(): void {
  if (!paused) return;
  paused = false;
  // The app never disables recording itself; remote config decides once this is false.
  if (posthog.__loaded) posthog.set_config({ disable_session_recording: false });
}
